import React from "react";
import PropTypes from "prop-types";
import ModalSuccess from "../../ModalSuccess";
import { AgGridReact } from "ag-grid-react";
import {
  ClientSideRowModelModule,
  ValidationModule,
  RowSelectionModule,
  TextFilterModule,
  NumberFilterModule,
  DateFilterModule,
  CustomFilterModule,
} from "ag-grid-community";
import $ from "jquery";
import { API_URL, GRID_COLUMN_EMPTY_ICONS } from "../../utils/Constants";
import { DeleteLogo } from "../../assets/icons";
import { SessionExpiredModal } from "../../components";
import { Button } from "react-bootstrap";

class UserManagementAGGrid extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      deleteSuccess: false,
      deleteSuccessMsg: "",
      sessionExpired: false,
      columnDefs: [
        {
          headerName: "User Name",
          field: "username",
          sortable: true,
          filter: true,
          icons: GRID_COLUMN_EMPTY_ICONS,
          resizable: false,
          flex: 2,
          minWidth: 150,
        },
        {
          headerName: "Name",
          field: "firstName",
          sortable: true,
          filter: true,
          icons: GRID_COLUMN_EMPTY_ICONS,
          resizable: false,
          flex: 1,
          minWidth: 100,
        },
        {
          headerName: "Role",
          field: "authorities.0",
          sortable: true,
          filter: true,
          icons: GRID_COLUMN_EMPTY_ICONS,
          resizable: false,
          flex: 1,
          minWidth: 100,
        },
        {
          headerName: "Edit",
          field: "emailAddress",
          colId: "view",
          cellRenderer: (params) => this.renderDeleteCmpt(params),
          resizable: false,
          flex: 0.5,
          minWidth: 50,
        },
      ],
      paginationPageSize: 20,
      rowData: null,
    };
    this.handleDelete = this.handleDelete.bind(this);
    this.sessionExpiredClose = this.sessionExpiredClose.bind(this);
  }
  componentDidMount() {
    $(".ag-cell").text("School Id").hide();
  }

  sessionExpiredClose() {
    this.setState({ sessionExpired: false });
  }

  renderDeleteCmpt = (params) => (
    <Button
      onClick={() => this.handleDelete(params.data.emailAddress)}
      disabled={
        localStorage.getItem("role") == "SALESADMIN" ? "disabled" : false
      }
      style={{
        cursor: "pointer",
        display: "flex",
        alignItems: "end",
        border: 'none',
        backgroundColor: "transparent",
        padding: "6px 0",
      }}
    >
      <DeleteLogo />
    </Button>
  );

  handleDelete = async (email) => {
    localStorage.setItem("emailDetail", email);
    let authCode = localStorage.getItem("bearer");
    // resetting state to get popup for repeated delete
    this.setState({ deleteSuccess: false, deleteSuccessMsg: "" });

    let AuthUrl = API_URL.DELETE_USER;

    if (email != "") {
      let data = {
        emailAddress: email,
      };

      fetch(AuthUrl, {
        method: "DELETE", // or 'PUT'
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
          Authorization: authCode,
          Accept: "application/json",
          "X-Auth-Token":
            "otk_ODMwYmI5OTUtNTg0Ni00NTMxLWE3YTMtZTE2ZWNmOWIxNmJh",
        },
      })
        .then((response) => {
          const auth = response.headers.get("Authorization");
          if (auth) localStorage.setItem("bearer", auth);

          return response.json();
        })
        .then((response) => {
          if (
            (response.error != undefined &&
              response.error.status_code === 401) ||
            response.status === "403"
          ) {
            this.setState({ sessionExpired: true });
            return;
          }
          this.setState({ studentValueList: response.body });
          if (response.status.code == "Y") {
            this.props.func();
            this.setState({ deleteSuccess: true });
            this.setState({ deleteSuccessMsg: response.status.message });
          }
        });
    }
  };

  onGridReady = (params) => {
    params.api.setGridOption("rowData", this.props.details);
  };
  render() {
    return (
      <div
        style={{ height: 586, width: "100%" }}
      >
        <AgGridReact
          columnDefs={this.state.columnDefs}
          rowData={this.props.details}
          onGridReady={this.onGridReady}
          modules={[
            ClientSideRowModelModule,
            ValidationModule,
            RowSelectionModule,
            TextFilterModule,
            NumberFilterModule,
            DateFilterModule,
            CustomFilterModule,
          ]}
        />

        {this.state.sessionExpired ? (
          <SessionExpiredModal
            show={this.state.sessionExpired}
            onHide={this.sessionExpiredClose}
          />
        ) : null}

        {this.state.deleteSuccess ? (
          <ModalSuccess
            uploadStatus={this.state.deleteSuccess}
            message={this.state.deleteSuccessMsg}
          />
        ) : null}
      </div>
    );
  }
}

UserManagementAGGrid.propTypes = {
  details: PropTypes.array,
  func: PropTypes.func,
};

export default UserManagementAGGrid;
